import { findFocusedRoute } from '@react-navigation/core';
export const findFocusedRouteKey = state => {
  var _findFocusedRoute;
  // @ts-ignore
  return (_findFocusedRoute = findFocusedRoute(state)) === null || _findFocusedRoute === void 0 ? void 0 : _findFocusedRoute.key;
};
//# sourceMappingURL=findFocusedRouteKey.js.map